import { jsxs as p, jsx as a } from "react/jsx-runtime";
import * as o from "@radix-ui/react-dropdown-menu";
import { forwardRef as s } from "react";
const l = {
  display: "flex",
  alignItems: "center",
  gap: "var(--space-2)",
  padding: "var(--space-1_5) var(--space-2_5)",
  borderRadius: "var(--radius-md)",
  fontSize: "var(--text-sm)",
  color: "var(--text-primary)",
  cursor: "pointer",
  outline: "none"
}, c = {
  backgroundColor: "var(--bg-elevated)",
  border: "1px solid var(--border-strong)",
  borderRadius: "var(--radius-lg)",
  boxShadow: "var(--shadow-md)",
  padding: "var(--space-1)",
  minWidth: 200,
  zIndex: "var(--z-popover-list)"
}, w = o.Root, f = o.Trigger, b = o.Portal, g = o.Group, v = o.RadioGroup, D = o.Sub, M = o.Root, h = s(function({ className: e, sideOffset: n = 6, style: r, ...t }, i) {
  return /* @__PURE__ */ a(o.Portal, { children: /* @__PURE__ */ a(
    o.Content,
    {
      ref: i,
      sideOffset: n,
      className: ["ls-dropdown-content", e].filter(Boolean).join(" "),
      style: { ...c, ...r },
      ...t
    }
  ) });
}), x = s(function({ className: e, style: n, ...r }, t) {
  return /* @__PURE__ */ a(
    o.Item,
    {
      ref: t,
      className: ["ls-dropdown-item", e].filter(Boolean).join(" "),
      style: { ...l, ...n },
      ...r
    }
  );
}), S = s(function({ className: e, style: n, children: r, ...t }, i) {
  return /* @__PURE__ */ p(
    o.CheckboxItem,
    {
      ref: i,
      className: ["ls-dropdown-item", e].filter(Boolean).join(" "),
      style: { ...l, paddingLeft: "var(--space-6)", ...n },
      ...t,
      children: [
        /* @__PURE__ */ a("span", { style: { position: "absolute", left: "var(--space-2)" }, children: /* @__PURE__ */ a(o.ItemIndicator, { children: "✓" }) }),
        r
      ]
    }
  );
}), I = s(function({ className: e, style: n, children: r, ...t }, i) {
  return /* @__PURE__ */ p(
    o.RadioItem,
    {
      ref: i,
      className: ["ls-dropdown-item", e].filter(Boolean).join(" "),
      style: { ...l, paddingLeft: "var(--space-6)", ...n },
      ...t,
      children: [
        /* @__PURE__ */ a("span", { style: { position: "absolute", left: "var(--space-2)" }, children: /* @__PURE__ */ a(o.ItemIndicator, { children: "●" }) }),
        r
      ]
    }
  );
}), y = s(function({ className: e, style: n, ...r }, t) {
  return /* @__PURE__ */ a(
    o.Label,
    {
      ref: t,
      className: ["ls-dropdown-label", e].filter(Boolean).join(" "),
      style: {
        padding: "var(--space-1_5) var(--space-2_5)",
        fontSize: "var(--text-2xs)",
        textTransform: "uppercase",
        letterSpacing: "0.04em",
        color: "var(--text-tertiary)",
        fontWeight: "var(--font-weight-semibold)",
        ...n
      },
      ...r
    }
  );
}), j = s(function({ className: e, style: n, ...r }, t) {
  return /* @__PURE__ */ a(
    o.Separator,
    {
      ref: t,
      className: ["ls-dropdown-separator", e].filter(Boolean).join(" "),
      style: {
        height: 1,
        margin: "var(--space-1) 0",
        backgroundColor: "var(--border-subtle)",
        ...n
      },
      ...r
    }
  );
}), C = s(function({ className: e, style: n, ...r }, t) {
  return /* @__PURE__ */ a(
    o.SubTrigger,
    {
      ref: t,
      className: ["ls-dropdown-item", e].filter(Boolean).join(" "),
      style: { ...l, ...n },
      ...r
    }
  );
}), R = s(function({ className: e, style: n, ...r }, t) {
  return /* @__PURE__ */ a(o.Portal, { children: /* @__PURE__ */ a(
    o.SubContent,
    {
      ref: t,
      className: ["ls-dropdown-content", e].filter(Boolean).join(" "),
      style: { ...c, ...n },
      ...r
    }
  ) });
});
export {
  M as D,
  S as a,
  h as b,
  g as c,
  x as d,
  y as e,
  b as f,
  v as g,
  I as h,
  w as i,
  j,
  D as k,
  R as l,
  C as m,
  f as n
};
//# sourceMappingURL=DropdownMenu-WvF2FJR5.js.map
